/// <amd-module name="Feed/CreateFeed/Components/ZeroFeedsPage" />
import * as React from "react";
import { connect } from "react-redux";
import { DynamicModuleLoader } from "redux-dynamic-modules";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { Button } from "VSSUI/Button";

import * as PackageResources from "Feed/Common/Resources";
import { FeedHubActions } from "Feed/Core/Redux/FeedHub/FeedHubActions";
import { WrappedCreateFeedPanel } from "Feed/Legacy/Components/WrappedCreateFeedPanel";

import { IZeroFeedsState } from "../Redux/ZeroFeeds/ZeroFeedsContracts";
import { ZeroFeedsModule } from "../Redux/ZeroFeeds/ZeroFeedsModule";
import { getZeroFeedsData } from "../Redux/ZeroFeeds/ZeroFeedsSelectors";

const Actions = {
    showCreateFeed: FeedHubActions.showCreateFeed
};

export interface IZeroFeedsPageProps {}

class ZeroFeedsPage extends VssComponent<IZeroFeedsPageProps & typeof Actions, {}> {
    private showCreateFeedPanelAction: () => void;
    private imagePath: string;
    private isUserAnonymousOrPublic: boolean;

    constructor(props: IZeroFeedsPageProps & typeof Actions, context?: IVssComponentContext) {
        super(props);
        const data: IZeroFeedsState = getZeroFeedsData(context!.pageContext);
        this.imagePath = data.imagePath;
        this.isUserAnonymousOrPublic = data.isUserAnonymousOrPublic;
        this.showCreateFeedPanelAction = () => props.showCreateFeed();
    }

    public render(): JSX.Element {
        return (
            <div className="zerofeeds">
                <div className="zerofeeds-container">
                    <img className="zerofeeds-image" src={this.imagePath} alt={""} />
                    <div className="zerofeeds-content">
                        <div>
                            {this.isUserAnonymousOrPublic
                                ? PackageResources.WelcomePanel_Public_Message
                                : PackageResources.WelcomePanel_Message}
                        </div>
                        {!this.isUserAnonymousOrPublic && (
                            <Button
                                iconProps={{ iconName: "Add" }}
                                primary={true}
                                onClick={this.showCreateFeedPanelAction}
                                text={PackageResources.NewFeedCommand}
                                className="create-feed-button"
                            />
                        )}
                    </div>
                </div>
                {!this.isUserAnonymousOrPublic && <WrappedCreateFeedPanel />}
            </div>
        );
    }
}

function mapStateToProps(): IZeroFeedsPageProps {
    return {};
}

const ConnectedZeroFeedsPage = connect(mapStateToProps, Actions)(ZeroFeedsPage);

class DynamicZeroFeedsPage extends React.PureComponent {
    public render() {
        return (
            <DynamicModuleLoader modules={ZeroFeedsModule}>
                <ConnectedZeroFeedsPage />
            </DynamicModuleLoader>
        );
    }
}

VssComponent.register("ms.feed.feed-createfeed.zerofeeds", DynamicZeroFeedsPage);
